import { render, staticRenderFns } from "./login-with-code.vue?vue&type=template&id=159e505f&"
import script from "./login-with-code.vue?vue&type=script&lang=ts&"
export * from "./login-with-code.vue?vue&type=script&lang=ts&"
import style0 from "./login-with-code.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports